const slider = document.getElementById('hero-yeni-slider');
    const slides = slider.querySelectorAll('.slide');
    const dotsContainer = document.getElementById('hero-yeni-dots');
    let current = 0;
    let interval;

    // Dot navigation
    slides.forEach((_, index) => {
      const dot = document.createElement('div');
      dot.classList.add('dot');
      if (index === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        current = index;
        showSlide(current);
        resetAutoplay();
      });
      dotsContainer.appendChild(dot);
    });

    const dots = slider.querySelectorAll('.dot');

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
        dots[i].classList.toggle('active', i === index);
      });
      adjustSliderHeight();
    }

    function nextSlide() {
      current = (current + 1) % slides.length;
      showSlide(current);
    }

    function startAutoplay() {
      interval = setInterval(nextSlide, 8000);
    }

    function resetAutoplay() {
      clearInterval(interval);
      startAutoplay();
    }

    function adjustSliderHeight() {
      const activeSlide = slider.querySelector('.slide.active');
      if (activeSlide) {
        const media = activeSlide.querySelector('img, video');
        if (media) {
          const checkHeight = () => {
            if (media.readyState >= 1 || media.complete) {
              slider.style.height = media.offsetHeight + 'px';
            } else {
              setTimeout(checkHeight, 100);
            }
          };
          checkHeight();
        }
      }
    }

    function setResponsiveVideoSources() {
      const videos = slider.querySelectorAll('video');
      const isMobile = window.innerWidth <= 1023;

      videos.forEach(video => {
        const mobileSrc = video.getAttribute('data-src-mobile');
        const desktopSrc = video.getAttribute('data-src-desktop');
        const targetSrc = isMobile ? mobileSrc : desktopSrc;

        if (!video.src.includes(targetSrc)) {
          video.src = targetSrc;
          video.load();
        }
      });
    }

    // Touch & Mouse Drag
    let startX = 0;
    let isDragging = false;

    function onStart(e) {
      isDragging = true;
      startX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    }

    function onMove(e) {
      if (!isDragging) return;
      const x = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
      const diff = x - startX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          current = (current - 1 + slides.length) % slides.length;
        } else {
          current = (current + 1) % slides.length;
        }
        showSlide(current);
        resetAutoplay();
        isDragging = false;
      }
    }

    function onEnd() {
      isDragging = false;
    }

    slider.addEventListener('mousedown', onStart);
    slider.addEventListener('mousemove', onMove);
    slider.addEventListener('mouseup', onEnd);
    slider.addEventListener('mouseleave', onEnd);
    slider.addEventListener('touchstart', onStart, { passive: true });
    slider.addEventListener('touchmove', onMove, { passive: true });
    slider.addEventListener('touchend', onEnd);

    // Başlat
    setResponsiveVideoSources();
    adjustSliderHeight();
    startAutoplay();

    window.addEventListener('resize', () => {
      setResponsiveVideoSources();
      adjustSliderHeight();
    });